export const ROUTES = {
  HOME: "/",
  SELECT_MACHINE: "/select-machine",
  SAP_NOTE: "/sap-note",
  DOCUMENTS: (id?: string) => "/documents" + `${id ? "/" + id : ""}`,
  COMPLETE_OPERATION: "/complete-operation",
  ROUTING: "/routing",
  DECLARE_DEVIATION: "/declare-deviation",
  OPCENTER: (resource: string, title?: string) =>
    `/opcenter/${resource}${title ? `?title=${title}` : ""}`,
  SENTENCE_NC: (ncNId: string) => "/sentence-nc/" + ncNId,
} as const;
